import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditCgp() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [cgpData, setCgpData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/types_partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne physique *******************************/
  const [pPData, setPpData] = useState({ data: [] });
  const [selectedPersonnePhysique, setSelectedPp] = useState("");
  const handlePersonneChange = (e) => {
    setSelectedPp(e);
  };
  const getPP = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/contacts`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setPpData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPpOptions = () => {
    return [
      {
        options: pPData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne Morale *******************************/
  const [pMData, setPmData] = useState({ data: [] });
  const [selectedPm, setSelectedPm] = useState("");
  const handlePmChange = (e) => {
    setSelectedPp(e);
  };
  const getPM = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/mes_cgps/partenaires?id=${id}&types_partenaire_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPmData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmOptions = () => {
    return [
      {
        options: pMData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type Personne *******************************/
  const [TypePersonneData, setTypePersonneData] = useState({ data: [] });
  const [selectedTypePersonne, setSelectedTypePersonne] = useState("");
  const handleTypePersonneChange = (e) => {
    setSelectedTypePersonne(e);
  };
  const getTypePersonne = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/type_personnes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setTypePersonneData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypePersonneOptions = () => {
    return [
      {
        options: TypePersonneData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Tête de réseau *******************************/
  const [teteReseauData, setTeteReseauData] = useState({ data: [] });
  const [selectedTeteReseau, setSelectedTeteReseau] = useState("");
  const handleTeteReseauChange = (e) => {
    setSelectedTeteReseau(e);
  };
  console.log(selectedTeteReseau);
  const getTeteReseau = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/societes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTeteReseauData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTeteReseauOptions = () => {
    return [
      {
        options: teteReseauData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Taux d'apport  *******************************/
  const [tauxData, setTauxData] = useState({ data: [] });
  const [selectedTaux, setSelectedTaux] = useState("");
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/taux_apports`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTauxData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Modèle dossier de souscription & TEPA  *******************************/
  const [modeleData, setModeleData] = useState({ data: [] });
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };
  const [selectedModeleT, setSelectedModeleT] = useState("");
  const handleModeleTChange = (e) => {
    setSelectedModeleT(e);
  };
  const getModele = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/mes_cgps/publipostages
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setModeleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeleOptions = () => {
    return [
      {
        options: modeleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Numero RCS *********************************/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /************************************* Code RCS *********************************/
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Défaut *********************************/
  const [selectedDefaut, setSelectedDefaut] = useState("");
  const handleDefautChange = (e) => {
    setSelectedDefaut(e);
  };
  /************************************* Trigramme *********************************/
  const [selectedTrigramme, setSelectedTrigramme] = useState("");
  const handleTrigrammeChange = (e) => {
    setSelectedTrigramme(e.target.value);
  };
  /************************************* Origine *********************************/
  const [selectedOrigine, setSelectedOrigine] = useState("");
  const handleOrigineChange = (e) => {
    setSelectedOrigine(e.target.value);
  };
  /************************************* Compte de créance *********************************/
  const [selectedCompteCreance, setSelectedCompteCreance] = useState("");
  const handleCompteCreanceChange = (e) => {
    setSelectedCompteCreance(e.target.value);
  };
  /************************************* Entrepreteurs *********************************/
  const [selectedEntrepreteur, setSelectedEntrepreteur] = useState("");
  const handleEntrepreteurChange = (e) => {
    setSelectedEntrepreteur(e);
  };
  /************************************* Date création activité *********************************/
  const [selectedDateCreation, setSelectedDateCreation] = useState("");
  const handleDateCreationChange = (e) => {
    setSelectedDateCreation(e.target.value);
  };
  /************************************* Surface totale détenue  *********************************/
  const [selectedSurfaceTotal, setSelectedSurfaceTotal] = useState("");
  const handleSurfaceTotalChange = (e) => {
    setSelectedSurfaceTotal(e.target.value);
  };
  /************************************* Surface exploitée   *********************************/
  const [selectedSurfaceExploit, setSelectedSurfaceExploit] = useState("");
  const handleSurfaceExploitChange = (e) => {
    setSelectedSurfaceExploit(e.target.value);
  };

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmitPm = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(`https://www.fluxod.com/${api}/mes_cgps`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            partenaire: {
              type_personne_id: selectedTypePersonne?.value,

              societe_id: selectedPm?.value,
              defaut: selectedDefaut?.value,
              types_partenaire_id: selectedType?.value,
              rcs: selectedNumero,
              code_ape: selectedCode,
              actif: selectedActif?.value,
              trigramme: selectedTrigramme,
              partenaire_id: selectedTeteReseau?.value,
              ///
              origine: selectedOrigine,
              taux_apport_id: selectedTaux.map((item) => item.value),
              publipostage_id: selectedModele?.value,
              publipostage2_id: selectedModeleT?.value,
              entrepreteurs: selectedEntrepreteur?.value,
              ///
              compte_de_creance: selectedCompteCreance,
            },
          }),
        });

        if (response.ok) {
          console.log("POST request successful");

          handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitP = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(`https://www.fluxod.com/${api}/mes_cgps`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            partenaire: {
              type_personne_id: selectedTypePersonne?.value,

              contact_id: selectedPersonnePhysique?.value,
              defaut: selectedDefaut?.value,
              types_partenaire_id: selectedType?.value,
              rcs: selectedNumero,
              code_ape: selectedCode,
              actif: selectedActif?.value,
              trigramme: selectedTrigramme,
              partenaire_id: selectedTeteReseau?.value,
              ///
              origine: selectedOrigine,
              taux_apport_id: selectedTaux?.map((item) => item.value) || "",
              publipostage_id: selectedModele?.value,
              publipostage2_id: selectedModeleT?.value,
              entrepreteurs: selectedEntrepreteur?.value,
              ///
              compte_de_creance: selectedCompteCreance,
            },
          }),
        });

        if (response.ok) {
          console.log("POST request successful");

          handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  /******************************* END Validation *******************************************/
  useEffect(() => {
    if (!loading) {
      getType();
      getPP();
      getTypePersonne();
      getPM();
      getTeteReseau();
      getTaux();
      getModele();
    }
  }, [loading]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Mes CGPS | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails CGP
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/mes_cgps/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Mes CGP
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          cgpData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Créer
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to={`${backUrl}/mes_cgps/`}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Identification
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Type personne* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedTypePersonne}
                                          onChange={handleTypePersonneChange}
                                          options={renderTypePersonneOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedTypePersonne === null
                                          )}
                                        />
                                        {selectedTypePersonne === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Type personne ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    {selectedTypePersonne?.label == "PP" ? (
                                      <>
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Personne Physique* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              defaultValue={
                                                selectedPersonnePhysique
                                              }
                                              onChange={handlePersonneChange}
                                              options={renderPpOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(
                                                selectedPersonnePhysique ===
                                                  null
                                              )}
                                            />
                                            {selectedPersonnePhysique ===
                                            null ? (
                                              <div
                                                style={{
                                                  color: "red",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Personne physique ne peut pas
                                                être vide
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </Col>
                                        </Row>
                                      </>
                                    ) : selectedTypePersonne?.label == "PM" ? (
                                      <Row className="mb-2">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span>Personne Morale :</span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-6">
                                          <Select
                                            defaultValue={selectedPm}
                                            onChange={handlePmChange}
                                            options={renderPmOptions()}
                                            isClearable={true}
                                            className="select2"
                                            styles={styles(false)}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Type * :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedType}
                                          onChange={handleTypeChange}
                                          options={renderTypeOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(selectedType === null)}
                                        />
                                        {selectedType === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Type ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>N° RCS :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedNumero}
                                          required
                                          onChange={handleNumeroChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Code APE :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedCode}
                                          required
                                          onChange={handleCodeChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Actif* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedActif}
                                          onChange={handleActifChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedActif === null
                                          )}
                                        />
                                        {selectedActif === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Actif ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Défaut :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedDefaut}
                                          onChange={handleDefautChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Trigramme :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedTrigramme}
                                          required
                                          onChange={handleTrigrammeChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Tête de réseau* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedTeteReseau}
                                          onChange={handleTeteReseauChange}
                                          options={renderTeteReseauOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedTeteReseau === null
                                          )}
                                        />
                                        {selectedTeteReseau === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Tête de réseau ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>

                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Données complémentaires CGP
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Origine :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedOrigine}
                                          required
                                          onChange={handleOrigineChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Taux d'apport (restriction) :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedTaux}
                                          onChange={handleTauxChange}
                                          options={renderTauxOptions()}
                                          isClearable={true}
                                          className="select2"
                                          isMulti={true}
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Modèle dossier de souscription :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedModele}
                                          onChange={handleModeleChange}
                                          options={renderModeleOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>
                                            Modèle dossier de souscription TEPA
                                            :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedModeleT}
                                          onChange={handleModeleTChange}
                                          options={renderModeleOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Entrepreteurs :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          defaultValue={selectedEntrepreteur}
                                          onChange={handleEntrepreteurChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        {" "}
                                        Données complémentaires Direction
                                        produit
                                      </CardTitle>
                                      <CardBody>
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Compte de créance :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={
                                                selectedCompteCreance
                                              }
                                              required
                                              onChange={
                                                handleCompteCreanceChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
